import { jsx as _jsx } from "nativewind/jsx-runtime";
import React, { useRef } from 'react';
import { FlatList, Platform } from 'react-native';
import styled from 'styled-components/native';
import { color } from '@/constant/color';
import { usePlaceDetailScreenName } from '@/hooks/useFeatureFlags';
import { LogParamsProvider } from '@/logging/LogParamsProvider';
import { useLogger } from '@/logging/useLogger';
import useNavigation from '@/navigation/useNavigation';
import SearchItemCard from '@/screens/SearchScreen/components/SearchItemCard';
import SearchLoading from '@/screens/SearchScreen/components/SearchLoading';
import SearchNoResult from '@/screens/SearchScreen/components/SearchNoResult';
const VIEWABILITY_CONFIG = { itemVisiblePercentThreshold: 50 };
export default function SearchListView({ searchResults, isLoading, isVisible, searchQuery, onWebPlaceClick, }) {
    const navigation = useNavigation();
    const pdpScreen = usePlaceDetailScreenName();
    const logger = useLogger();
    const loggerRef = useRef(logger);
    loggerRef.current = logger;
    const loggedItemsRef = useRef(new Set());
    // Reset logged items when search results change
    const prevSearchResultsRef = useRef(searchResults);
    if (prevSearchResultsRef.current !== searchResults) {
        prevSearchResultsRef.current = searchResults;
        loggedItemsRef.current.clear();
    }
    const onViewableItemsChanged = useRef(({ viewableItems }) => {
        viewableItems.forEach(({ item }) => {
            const placeItem = item;
            const key = placeItem.place.id;
            if (!loggedItemsRef.current.has(key)) {
                loggedItemsRef.current.add(key);
                loggerRef.current.logElementView('place_search_item_card', {
                    search_view_mode: 'list',
                    place_id: placeItem.place.id,
                    place_name: placeItem.place.name,
                });
            }
        });
    }).current;
    return (_jsx(LogParamsProvider, { params: { search_view_mode: 'list' }, children: _jsx(Container, { isVisible: isVisible, children: isLoading ? (_jsx(SearchLoading, {})) : searchResults.length === 0 ? (_jsx(SearchNoResult, {})) : (_jsx(FlatList, { contentContainerStyle: { paddingBottom: 100 }, keyboardDismissMode: "on-drag", onViewableItemsChanged: onViewableItemsChanged, viewabilityConfig: VIEWABILITY_CONFIG, renderItem: ({ item }) => (_jsx(ItemWrapper, { children: _jsx(SearchItemCard, { item: item, isHeightFlex: true, onPress: () => {
                            if (searchQuery && Platform.OS === 'web') {
                                // Web: Use window.history.pushState like map marker click
                                onWebPlaceClick === null || onWebPlaceClick === void 0 ? void 0 : onWebPlaceClick(item.place.id);
                                return;
                            }
                            // Native app navigation
                            navigation.navigate(pdpScreen, {
                                placeInfo: {
                                    placeId: item.place.id,
                                },
                                specialAccessibility: item.specialAccessibility,
                            });
                        } }) }, item.place.id)), data: searchResults })) }) }));
}
const Container = styled.View `
  display: ${props => (props.isVisible ? 'flex' : 'none')};
  flex-direction: column;
  flex: 1;
  background-color: ${color.white};
`;
const ItemWrapper = styled.View `
  padding: 20px;
  border-top-width: 1px;
  border-top-color: ${() => color.gray20};
`;
